import type { FieldPolicy } from "@apollo/client"

export const basemapCacheFields: Record<string, FieldPolicy> = {
  // Opening a basemap the table already loaded reads the normalized record
  // instead of waiting on a round trip; the sheet then updates in place
  // from every mutation that returns the basemap.
  getBasemapByFeatureCode: {
    merge: false,
    read(_, { args, toReference, canRead }) {
      if (!args?.featureCode) return
      const ref = toReference({
        __typename: "Basemap",
        FeatureCode: args.featureCode,
      })
      if (ref && canRead(ref)) return ref
    },
  },
}
